import { PostType } from '~/widgets/Stories'
import { useDrawer } from '~/shared/ui/Drawer'
import { ChevronUpIcon } from '~/shared/ui/icons'
import { Img } from '~/shared/ui/Img'
import { ShowMoreDrawer } from '../ShowMoreDrawer'
import {
  Button,
  ContentBlur,
  DescriptionWrapper,
  ImageWrapper,
  NextBlock,
  PostContent,
  PrevBlock,
  ShowMore,
  TitleWrapper,
} from './styled'
import { useLongPress } from './useLongPress'

type PostProps = {
  onPause: () => void
  onResume: () => void
  onNext: () => void
  onBack: () => void
  post: PostType
}

export function Post({ onPause, onResume, onNext, onBack, post }: PostProps) {
  const pressEvents = useLongPress({
    onLongPressStart: onPause,
    onLongPressEnd: onResume,
  })

  const [isShowMoreVisible, showMoreOpen, showMoreClose] = useDrawer()

  const handleShowMoreOpen = () => {
    onPause()
    showMoreOpen()
  }

  const handleShowMoreClose = () => {
    onResume()
    showMoreClose()
  }

  return (
    <>
      <PostContent>
        <PrevBlock {...pressEvents} onClick={onBack} />
        <NextBlock {...pressEvents} onClick={onNext} />

        {post?.title && (
          <ContentBlur style={{ marginBottom: '8px' }}>
            <TitleWrapper $lineClamp={2}>{post.title}</TitleWrapper>
          </ContentBlur>
        )}

        {post?.description && (
          <ContentBlur style={{ marginBottom: '24px' }}>
            <DescriptionWrapper $lineClamp={3}>
              {post.description}
            </DescriptionWrapper>
          </ContentBlur>
        )}

        {post?.content && (
          <ShowMore onClick={handleShowMoreOpen}>
            <span>Читать дальше</span>
            <ChevronUpIcon />
          </ShowMore>
        )}

        {post?.externalLink && (
          <Button
            href={post.externalLink}
            target='_blank'
            variant='limeFlooded'
            size='large'
          >
            Перейти
          </Button>
        )}
      </PostContent>
      <ImageWrapper>
        <Img url={post.img} />
      </ImageWrapper>

      {post?.content && (
        <ShowMoreDrawer
          content={post.content}
          onClose={handleShowMoreClose}
          isShow={isShowMoreVisible}
        />
      )}
    </>
  )
}
